var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcGooglelogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 8.18411C16.4999 7.64031 16.455 7.09357 16.359 6.55859H8.66113V9.63914H13.0693C12.8864 10.6327 12.2987 11.5116 11.438 12.0701V14.0689H14.0679C15.6123 12.6756 16.4999 10.618 16.4999 8.18411Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66071 16C10.8618 16 12.7181 15.2916 14.0705 14.0688L11.4406 12.07C10.7089 12.5579 9.76426 12.8342 8.66371 12.8342C6.53458 12.8342 4.72931 11.4262 4.08157 9.5332H1.36768V11.5938C2.75311 14.2951 5.57497 16 8.66071 16Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07905 9.53314C3.73718 8.5396 3.73718 7.46376 4.07905 6.47023V4.40967H1.36815C0.210618 6.67011 0.210618 9.33326 1.36815 11.5937L4.07905 9.53314Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66071 3.16633C9.82424 3.1487 10.9488 3.57786 11.7914 4.36563L14.1215 2.08167C12.6461 0.723645 10.6879 -0.0229766 8.66071 0.000539093C5.57497 0.000539093 2.75311 1.70542 1.36768 4.40972L4.07857 6.47028C4.72331 4.57433 6.53158 3.16633 8.66071 3.16633Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGooglelogo);
export default __webpack_public_path__ + "static/media/ic_google logo.9cbac1bb1684601fdbf4e56da53fde1a.svg";
export { ForwardRef as ReactComponent };